
'use strict'

class Input{
    
    constructor(input){
        this.allowed = [];
        this._input = input;
        
        this._isNumeric = false;

        this._input.addEventListener('keydown', this._onKeyDown.bind(this));
        this._input.addEventListener('paste', this._onPaste.bind(this));
    }

    _onKeyDown(e){
        let allowed = [37,39,46];//arrows and supr
        if (this.allowed){
            allowed = allowed.concat(this.allowed);
        }

        if(this._isNumeric && e.keyCode > 31 && !(e.keyCode >= 48 && e.keyCode <= 57) && !(e.keyCode >= 96 && e.keyCode <= 105) && allowed.indexOf(e.keyCode) == -1){
            e.preventDefault();
        }
    }

    _onPaste(e){
        if(this._isNumeric && isNaN(e.clipboardData.getData('text'))){
            e.preventDefault();
        }                       
    }
    
    set error(value){
        if(value){
            this._input.closest('.form__group').classList.add('form__group--error');
        }else{
            this._input.closest('.form__group').classList.remove('form__group--error');
        }
    }
    
    set value(value){
        this._input.value = value;
    }
    
    get value(){
        return this._input.value.trim();
    }

    set numeric(allowed){
        if (allowed){
            this.allowed = allowed;
        }
        this._isNumeric = true;
    }

    focus(){
        this._input.focus();
    }

    empty(){
        this._input.value = "";
    }

    reset(){
        this.empty();
        this.error = false;
    }

    get isEmpty(){
        return this.value.replace(/(^\s*)|(\s*$)|[ ]/g, "").length == 0;
    }

    get isValidEmail(){
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.value);
    }
    
    get isValidPhone(){
        return this.value !== '' && this.value.replace(/([0-9()+]{8,20})/gi, '') === '' ? true : false;
    }


    get input(){
        return this._input;
    }

}

export default Input;
